import React, { createContext, useContext, useState } from 'react';

const VisibilityContext = createContext();

const VisibilityProvider = ({ children }) => {
  const [showFooter, setShowFooter] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  return (
    <VisibilityContext.Provider
      value={{
        showFooter,
        setShowFooter,
        showContent,
        setShowContent,
        showLoader,
        setShowLoader,
      }}>
      {children}
    </VisibilityContext.Provider>
  );
};

const useVisibility = () => {
  const context = useContext(VisibilityContext);

  if (!context) {
    throw new Error('useVisibility must be used within a VisibilityProvider');
  }
  return context;
};

export { VisibilityContext, VisibilityProvider, useVisibility };
